export const getPurchaseReturnList = state => {
  return state.purchaseReturnList
}

export const getPurchaseReturnInfo = state => {
  return state.purchaseReturnInfo
}

export const getUnClosedPurchaseReturnCount = state => {
  return state.unClosedPurchaseReturnCount
}

export const getUnPaidPurchaseReturnCount = state => {
  return state.unPaidPurchaseReturnCount
}
